import UrlHelper from '../core/UrlHelper';
import RunningMode from '../RunningMode';
import AssetsManager from '../assets_management/AssetsManager';
export default class Urls{
	static get backendPort(){
		const thisPagePort = window.location.port;
		return RunningMode.isDevelopment?51395:(thisPagePort===80?null:thisPagePort);
	}
	static get root(){
		const backendPortString = Urls.backendPort!==null?`:${Urls.backendPort}`:'';
		return `${window.location.protocol}//${window.location.hostname}${backendPortString}/`;
	}
	static getBrochureGenerator(){
		return RunningMode.isDevelopment?`${Urls.root}brochureGeneration/`:AssetsManager.configuration.brochureGeneratorUrl;
	}
	static getSiteInfo(configuration){
		return RunningMode.isDevelopment?`${Urls.root}siteInfo/`:UrlHelper.makeSureSlashOnEnd(configuration.siteInfoUrl);
	}
	static getLatestSiteInfo(configuration){
		return `${Urls.getSiteInfo(configuration)}latestSiteInfo?siteName=${configuration.siteSlugForLatestSiteInfo?configuration.siteSlugForLatestSiteInfo:configuration.siteSlug}`;
	}
	static getQuadrantsAbsolutePath({configuration, relativePath}){
		return `${Urls.root}assets/${configuration.siteSlug}/${relativePath}`;
	}
	static getGeneratePDFBrochureSimple(){
		return `${Urls.getBrochureGenerator()}generatePDFBrochureSimple`;
	}
	static get assets(){
		return `${Urls.root}assets/${AssetsManager.configuration.siteSlug}/`;
	}
	static getAssetsForSite(siteSlug){
		return `${Urls.root}assets/${siteSlug}/`;
	}
	static get videos(){
		return Urls.assets+'videos/';
	}
	static get siteIcon(){
		return Urls.assets+'icons/site-icon.png';
	}
	static get developerIcon(){
		return Urls.assets+'icons/developer-icon.png';
	}
	static getConfigurationJSON(){
		return `${Urls.assets}configuration.json`;
	}
	static getIcon(iconRelativePath){
		return Urls.getIcons()+iconRelativePath;
	}
	static getBrochureGenerationCheckProgress(){
		return `${Urls.getBrochureGenerator()}checkProgress`;
	}
	static getBrochureGenerationGetBrochuresForSession(){
		return `${Urls.getBrochureGenerator()}getBrochuresForSession`;
	}
	static getConfiguratorUrlForPlot(plot, configuration){
		const configuratorRootUrl = configuration.configuratorRootUrl;
		if(configuratorRootUrl)
		{
			return`${configuratorRootUrl}${plot.number}`;
		}
		let url = plot.houseType?.configuratorUrl;
		if(url) url +=`?plot=${plot.number}`;
		else url = plot.houseType?.tourUrl;
		return url;
	}
	static getSiteAssets_3D(configuration){
		return Urls.getAssetsForSite(configuration.siteSlug)+'3d/';
	}
	static getOutside360(configuration){
		return Urls.getAssetsForSite(configuration.siteSlug)+'outside_360/';
	}
	static getIcons(){
		return Urls.assets;
	}
	static getSiteJson(configuration){
		return Urls.getAssetsForSite(configuration.siteSlug)+'site.json';
	}
}